<template>
  <div id="app" class="min-h-screen" :class="{ 'fa': $i18n.locale == 'fa', 'en': $i18n.locale != 'fa' }">
    <router-view />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import axios from "axios";
export default {
  created() {
    axios.interceptors.request.use(
      (config) => {
        this.$store.commit("LOADING", true);
        return config;
      },
      (error) => {
        this.$store.commit("LOADING", false);
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        this.$store.commit("LOADING", false);
        return response;
      },
      (error) => {
        this.$store.commit("LOADING", false);
        return Promise.reject(error);
      }
    );
    const updated = localStorage.getItem("updated");
    if (updated == null) {
      this.prompt = true;
    }
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        console.log("waiting");
        this.prompt = true;
      });
    }
  },
  data() {
    return {
      prompt: false,
    };
  },
  computed: {
    ...mapGetters([
      "isLoading",
      "force_reset_password",
      "isMobileVerified",
      "mobile",
      "locale",
    ]),
  },
  methods: {
    async update() {
      localStorage.setItem("updated", true);
      window.location.reload();
      this.prompt = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    },
  },
  watch: {
    locale() {
      this.$router.replace({ params: { lang: this.locale } }).catch(() => { });
      this.$store.dispatch("changeLocale", this.locale);

    },
  },
};
</script>
<style lang="scss">
@import "./index.css";
@import "./assets/index.scss";
</style>
